import React from "react";
import { RCCBadge, RCCHidden } from "react-common-components";
import { useHistory } from "react-router-dom";
import Title from "src/components/Title";
import WrapText from "src/components/WrapText";
import { useTranslation } from "src/context/Translations/context";
import { checkSituationOccurrence, GroupersOccurrence } from "src/pages/Occurrences/Panel/interface";
import { IDashboardOccurrencesData } from "../interface";

interface ILI{
    data?: IDashboardOccurrencesData;
}

const Li: React.FC<ILI> = ({
	data
}) => {
	const { translate } = useTranslation();

	const history = useHistory();

	if(!data)
		return <div></div>;

	return (
		<>
			<div>
				<Title color="purple" size="sm">
					<WrapText lineClamp={1}>
						{data.title}
					</WrapText>
				</Title>
			</div>
			<div>
				<RCCBadge color="blue" layout="isSquare" onClick={() => history.push(`/occurrences/panel/?sector=${data.id}&situation=${checkSituationOccurrence.NOT_STARTED}&grouper=${GroupersOccurrence.SECTOR}&late=N`) }>
					{data.notStarted}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Não iniciadas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="purple" layout="isSquare" onClick={() => history.push(`/occurrences/panel/?sector=${data.id}&situation=${checkSituationOccurrence.OPENED}&grouper=${GroupersOccurrence.SECTOR}`)}>{data.opened}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Em andamento")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="red" layout="isSquare" onClick={() => history.push(`/occurrences/panel/?sector=${data.id}&grouper=${GroupersOccurrence.SECTOR}&late=S`)}>{data.late}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Atrasadas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="green" layout="isSquare" onClick={() => history.push(`/occurrences/panel/?sector=${data.id}&situation=${checkSituationOccurrence.FINISHED}&grouper=${GroupersOccurrence.SECTOR}`)}>{data.finished}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Concluídas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="grey" layout="isSquare"  onClick={() => history.push(`/occurrences/panel/?sector=${data.id}&situation=${checkSituationOccurrence.CANCELED}&grouper=${GroupersOccurrence.SECTOR}`)}>{data.canceled}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Canceladas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="black" layout="isSquare" onClick={() => history.push(`/occurrences/panel/?sector=${data.id}&situation=${checkSituationOccurrence.DISAPPROVED}&grouper=${GroupersOccurrence.SECTOR}`)}>{data.disaproved}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Desaprovadas")}
				</RCCHidden>
			</div>
		</>
	);
};

export default Li;
